var _title, _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPaperBag = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  className: "icon icon--paper-bag",
  viewBox: "0 0 58.91 59.2",
  width: 17,
  height: 17,
  ref: svgRef
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "icon--paper-bag__title"
}, "Paper Bag")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
  id: "icon--paper-bag__description"
}, "Pickup order type")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M54.54 10.89l1.86-.19a1.36 1.36 0 0 0 1-2l-4.83-8a1.31 1.31 0 0 0-1.25-.7l-40 3.46a1.36 1.36 0 0 0-1.21 1L0 50.73a1.34 1.34 0 0 0 .28 1.15 1.39 1.39 0 0 0 1.07.49l7.32-.16 7.75 6.67a.91.91 0 0 0 .17.09 1.94 1.94 0 0 0 .24.15 1.64 1.64 0 0 0 .32.05h.32l40.23-5a1.35 1.35 0 0 0 1.17-1.48zM10.06 49.83a1.33 1.33 0 0 0-.88-.33L3 49.63l9.54-43.56 38.17-3.3L54 8.23l-35.63 3.66-3-4.24A1.35 1.35 0 0 0 13 8.77v.12l2.83 45.86zm8.53 6.5l-2.66-43.22.69 1a1.35 1.35 0 0 0 1.24.56l34-3.49 4.23 40.48z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.18 51.7a.86.86 0 0 1-.8-.9l1.04-18.5a.85.85 0 1 1 1.69.1L10 50.9a.85.85 0 0 1-.82.8z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPaperBag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconPaperBag.37c6fc5d.svg";
export { ForwardRef as ReactComponent };